import { FaHome, FaRegNewspaper, FaWallet } from 'react-icons/fa';
import constant from '../../utils/constant';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { CgWebsite } from 'react-icons/cg';
import { IoMdSettings } from 'react-icons/io';
import { TiContacts } from 'react-icons/ti';
import { RiPaintBrushFill } from 'react-icons/ri';
import { FcDataConfiguration } from 'react-icons/fc';

export const SidebarData = [
	{
		title: 'Dashboard',
		icon: <FaHome />,
		link: constant.Routes.Admin.Dashboard,
	},
	{
		title: 'Products',
		icon: <CgWebsite />,
		link: constant.Routes.Admin.Products,
	},
	{
		title: 'Orders',
		icon: <AiOutlineShoppingCart />,
		link: constant.Routes.Admin.Orders,
	},
	{
		title: 'Configuration',
		icon: <FcDataConfiguration />,
		link: constant.Routes.Admin.WebsiteConfiguration,
	},
	{
		title: 'Themes',
		icon: <RiPaintBrushFill />,
		link: constant.Routes.Admin.ThemeSelector,
	},
	// {
	// 	title: 'Wallet',
	// 	icon: <FaWallet />,
	// 	link: constant.Routes.Admin.Wallet,
	// },
	// {
	// 	title: 'Contact Us Request',
	// 	icon: <TiContacts />,
	// 	link: constant.Routes.Admin.ContactUs,
	// },
	// {
	// 	title: 'Newsletter Subscription',
	// 	icon: <FaRegNewspaper />,
	// 	link: constant.Routes.Admin.NewsLetter,
	// },
	// {
	// 	title: 'Settings',
	// 	icon: <IoMdSettings />,
	// 	link: constant.Routes.Admin.Settings,
	// },
];
